import { render, staticRenderFns } from "./TicketView.vue?vue&type=template&id=56d05698&scoped=true&"
import script from "./TicketView.vue?vue&type=script&lang=js&"
export * from "./TicketView.vue?vue&type=script&lang=js&"
import style0 from "./TicketView.vue?vue&type=style&index=0&id=56d05698&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d05698",
  null
  
)

export default component.exports